import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
// @ts-expect-error - TS2614 - Module '"@atlaskit/dynamic-table"' has no exported member 'HeadType'. Did you mean to use 'import HeadType from "@atlaskit/dynamic-table"' instead?
import type { HeadType } from '@atlaskit/dynamic-table';
import type { ActionLink } from '@atlassian/jira-admin-pages-common/src/ui/actions-cell/types';
import type { Screen } from '@atlassian/jira-admin-screens-services/src/common/types.tsx';
import {
	buildConfigureScreenJSPUrl,
	buildEditScreenJSPUrl,
	buildCopyScreenJSPUrl,
	buildDeleteScreenJSPUrl,
} from '@atlassian/jira-admin-screens-services/src/services/screens-service/actions/utils.tsx';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import messages from './messages';

// width is specified in percentages
export const createHeaderRow = (formatMessage: FormatMessage): HeadType => ({
	cells: [
		{
			key: 'name',
			content: formatMessage(messages.name),
			isSortable: true,
			width: 35,
		},
		{
			key: 'screenSchemes',
			content: formatMessage(messages.screenSchemes),
			isSortable: false,
			width: 30,
		},
		{
			key: 'workflowTransitions',
			content: formatMessage(messages.workflowTransitions),
			isSortable: false,
			width: 30,
		},
		{
			key: 'actions',
			content: formatMessage(messages.actions),
			isSortable: false,
			width: 5,
		},
	],
});

export const buildActionLinks = (screen: Screen, formatMessage: FormatMessage): ActionLink[] => {
	const { id, screenSchemes, workflowTransitions } = screen;
	const isScreenUsed =
		(screenSchemes?.total != null && screenSchemes.total > 0) ||
		(workflowTransitions?.total != null && workflowTransitions.total > 0);

	return [
		{
			displayMessage: formatMessage(messages.configure),
			href: buildConfigureScreenJSPUrl(id),
			onItemClickHandleAnalytics: (analyticsEvent: UIAnalyticsEvent) =>
				fireUIAnalytics(analyticsEvent, 'configure'),
		},
		{
			displayMessage: formatMessage(messages.edit),
			href: buildEditScreenJSPUrl(id),
			onItemClickHandleAnalytics: (analyticsEvent: UIAnalyticsEvent) =>
				fireUIAnalytics(analyticsEvent, 'edit'),
		},
		{
			displayMessage: formatMessage(messages.copy),
			href: buildCopyScreenJSPUrl(id),
			onItemClickHandleAnalytics: (analyticsEvent: UIAnalyticsEvent) =>
				fireUIAnalytics(analyticsEvent, 'copy'),
		},
		...(isScreenUsed
			? []
			: [
					{
						displayMessage: formatMessage(messages.delete),
						href: buildDeleteScreenJSPUrl(id),
						onItemClickHandleAnalytics: (analyticsEvent: UIAnalyticsEvent) =>
							fireUIAnalytics(analyticsEvent, 'delete'),
					},
				]),
	];
};

export const getAnalyticsAttributes = (
	screen: Screen,
): {
	[key: string]: string | number | boolean | undefined;
} => ({
	screenId: `${screen.id}`,
	screenHasDescription: !!screen.description,
	screenSchemeCount: screen?.screenSchemes?.total,
	workflowTransitionsCount: screen.workflowTransitions?.total,
});
